import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createPartyEntry = createAsyncThunk('createPartyEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertParty`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updatePartyEntry = createAsyncThunk('updatePartyEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateParty`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPartyData = createAsyncThunk('fetchPartyData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPartylist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleParty = createAsyncThunk('fetchSingleParty', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPartylist&partyId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleParty = createAsyncThunk('deleteSingleParty', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteParty&partyId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const partySlice = createSlice({
    name: 'PartyData',
    initialState: {
        isLoading: false,
        party: null,
        deleteParty: null,
        singleParty: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPartyData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPartyData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.party = action.payload;
        });
        builder.addCase(fetchPartyData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleParty.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleParty.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteParty = action.payload;
        });
        builder.addCase(deleteSingleParty.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleParty.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleParty.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleParty = action.payload;
        });
        builder.addCase(fetchSingleParty.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });




    }
});

export default partySlice.reducer;
